export default {
  adimplencia: []
}
